export const WELCOME_GIFT_EXPIRED_STATUS_LABEL_INFERENCE = '기간 만료';
export const WELCOME_GIFT_OUTFIT_EXPIRED_STATUS_LABEL = '제출 기한 만료';

const benefitLabels = {
    onyou: '온유상조',
    outfit: '아웃핏코드',
};

const formatSelectedAt = (value) => {
    if (typeof value !== 'string' || value.length < 16) return '-';
    return value.slice(0, 16);
};

export const getWelcomeGiftDisplay = (data = {}) => {
    const product = data.welcome_gift_selected_product;
    const status = data.welcome_gift_status;
    let statusLabel = '-';

    if (status === 'OUTFIT_PHOTOS_REQUIRED' && product === 'outfit') {
        statusLabel = '사진 제출 필요';
    } else if (status === 'COMPLETED' && product === 'onyou') {
        statusLabel = '가입 완료';
    } else if (status === 'COMPLETED' && product === 'outfit') {
        statusLabel = '신청 완료';
    } else if (status === 'EXPIRED' && product === 'outfit') {
        statusLabel = WELCOME_GIFT_OUTFIT_EXPIRED_STATUS_LABEL;
    } else if (status === 'EXPIRED') {
        // TID-1458 첨부 화면에는 EXPIRED 예시가 없어 제품 의미로 확정한 표시 문구다.
        statusLabel = WELCOME_GIFT_EXPIRED_STATUS_LABEL_INFERENCE;
    }

    return {
        eligible: Number(data.welcome_gift_eligible_yn) === 1 ? '대상' : '비대상',
        benefit: benefitLabels[product] || '미선택',
        selected_at: formatSelectedAt(data.welcome_gift_selected_at),
        status: statusLabel,
    };
};

export const omitWelcomeGiftReadFields = (data = {}) => {
    const writableData = {...data};
    delete writableData.welcome_gift_eligible_yn;
    delete writableData.welcome_gift_selected_product;
    delete writableData.welcome_gift_selected_at;
    delete writableData.welcome_gift_status;
    return writableData;
};

const welcomeGiftFilterDefinitions = [
    {
        filterText: '웰컴기프트 대상 여부',
        paramKey: 'welcomeGiftTargetType',
        orderLists: [
            {name: '대상', type: 1},
            {name: '비대상', type: 2},
        ],
    },
    {
        filterText: '웰컴기프트 선택 혜택',
        paramKey: 'welcomeGiftBenefitType',
        orderLists: [
            {name: '미선택', type: 1},
            {name: '온유상조', type: 2},
            {name: '아웃핏코드', type: 3},
        ],
    },
];

export const createWelcomeGiftFilterLists = (param, setParam) =>
    welcomeGiftFilterDefinitions.map(({filterText, paramKey, orderLists}) => ({
        filterText,
        orderLists,
        checkedType: true,
        onChange: (event, type) => {
            const next = {...param};
            const selected = Array.isArray(param[paramKey]) ? param[paramKey] : param[paramKey] ? [param[paramKey]] : [];
            const values = event.target.checked
                ? [...new Set([...selected, type])].sort((left, right) => left - right)
                : selected.filter((value) => value !== type);
            if (values.length > 0) next[paramKey] = values;
            else delete next[paramKey];
            setParam(next);
        },
        orderbyType: param[paramKey],
    }));
